// Step titles and captions for the EntireDB cell, mirror propagation and
// Antithesis diagrams in "A Git Forge Without a Center". Spokes and Continuity
// keep their steps in spokes-diagram-data.ts and continuity-diagram-data.ts,
// next to the layout data each step drives. All of these files stay free of
// React and CSS so build/article-markdown.ts can export the steps as the
// post's Markdown.

export interface DiagramStep {
  title: string
  caption: string
}

export const mirrorPropagationSteps: DiagramStep[] = [
  {
    title: "Reads stay local",
    caption:
      "A fetch for main is served from the AU mirror’s own copy — no round trip to the home cell.",
  },
  {
    title: "A write is forwarded",
    caption:
      "AU forwards the push to the home cell in EU, the authoritative upstream every mirror defers to.",
  },
  {
    title: "Accepted, then broadcast",
    caption:
      "The home cell moves main to 3f2a, acknowledges the push, and propagates it to every mirror.",
  },
  {
    title: "Mirrors catch up",
    caption:
      "AU pulls the updated pack from the home cell while IN and US keep syncing in parallel.",
  },
  {
    title: "Every mirror converges",
    caption: "AU, IN, and US all read main at 3f2a — reads stay local and writes stay consistent.",
  },
]

export const entireDbCellSteps: DiagramStep[] = [
  { title: "Fan out the pack", caption: "Node A streams pack 3f2a to every node in the cell." },
  { title: "Stage + validate", caption: "Each node stages the pack, invisible to readers." },
  {
    title: "Two AZs staged",
    caption: "Every node confirms the staged pack and a complete object graph.",
  },
  {
    title: "Promote immutable objects",
    caption: "Each node promotes its staged pack into immutable storage.",
  },
  { title: "Two AZs durable", caption: "Two availability zones confirm the pack is durable." },
  {
    title: "Move main with CAS",
    caption: "Node A moves main from a91e to 3f2a with a compare-and-swap.",
  },
  {
    title: "Acknowledge the push",
    caption: "The push is acknowledged once the compare-and-swap succeeds.",
  },
  {
    title: "Node C reads main",
    caption: "A separate fetch opens on Node C, which reads main from PostgreSQL.",
  },
  {
    title: "Fill from Node B",
    caption: "Node C fills the pack's objects from Node B before serving them.",
  },
  {
    title: "Resolve pack + tip",
    caption: "The fetch resolves pack 3f2a as the new tip of main.",
  },
]

export const antithesisCaption =
  "An advertised ref returns the complete object graph or a clean error, never partial data."
